import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import BackToTop from './components/BackToTop';
import Home from './pages/Home';
import About from './pages/About';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import Contact from './pages/Contact';
import Archive from './pages/Archive';
import Manifesto from './pages/Manifesto';
import Dossier from './pages/Dossier';
import BlogArticle from './pages/BlogArticle';
import SpomenikMaps from './pages/SpomenikMaps';
import Shipping from './pages/Shipping';
import Returns from './pages/Returns';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import VirtualSpomenik from './pages/VirtualSpomenik';
import { trackPageView } from './src/utils/analytics';

// Analytics tracker component
const AnalyticsTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
};

const App: React.FC = () => {
  return (
    <Router>
      <AnalyticsTracker />
      <ScrollToTop />
      <BackToTop />
      <div className="min-h-screen border-[12px] md:border-[20px] border-black selection:bg-[#C41E3A] selection:text-white">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/products" element={<Products />} />
          <Route path="/product/:slug" element={<ProductDetail />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/archive" element={<Archive />} />
          <Route path="/manifesto" element={<Manifesto />} />
          <Route path="/dossier" element={<Dossier />} />
          <Route path="/dossier/:slug" element={<BlogArticle />} />
          <Route path="/spomenik-maps" element={<SpomenikMaps />} />
          <Route path="/virtual-spomenik" element={<VirtualSpomenik />} />
          <Route path="/shipping" element={<Shipping />} />
          <Route path="/returns" element={<Returns />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
